import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  action?: { label: string; to: string };
}

export default function SectionHeading({ title, subtitle, icon, action }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500/15 text-primary-500">
            <i className={`${icon} text-xl`} />
          </span>
        )}
        <div>
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950">{title}</h2>
          {subtitle && <p className="text-xs md:text-sm text-foreground-600 mt-0.5">{subtitle}</p>}
        </div>
      </div>
      {action && (
        <Link
          to={action.to}
          className="shrink-0 flex items-center gap-1 text-sm text-foreground-600 hover:text-accent-500 transition-colors whitespace-nowrap"
        >
          {action.label}
          <i className="ri-arrow-right-s-line text-base" />
        </Link>
      )}
    </div>
  );
}